import React, {useEffect} from 'react'
import axios from "axios";
import {Link, useNavigate} from "react-router-dom";

const CandidateCard = ({ application }) => {
  const navigate = useNavigate();
  const cleanProfilePicturePath = (path) => {
    if (path && path.startsWith("/")) {
      return path.substring(1);
    }
    return path;
  };
  return (
    <div className="col-lg-6 mb-4">
      <div className="card shadow-sm h-100">
        <div className="card-body">
          <div className="d-flex mb-3">
            <div className="candidate-img me-3">
              <img
              loading="lazy"
              role="presentation"
              decoding="async"
              fetchpriority="high"              
                src={application.candidate_profile_picture ?
                  `${process.env.REACT_APP_API_URL}${cleanProfilePicturePath(application.candidate_profile_picture)}` :
                  "/assets/img/candidate/default.jpg"}
                alt={application.candidate_name}
                className="rounded-circle"
                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
              />
            </div>
            <div className="candidate-info flex-grow-1">
              <div className="d-flex justify-content-between">
                <div>
                  <h5 className="mb-1">{application.candidate_name}</h5>
                  <p className="text-muted mb-1">{application.currentDesignation}</p>
                  <p className="small mb-0">
                    <i className="far fa-building me-1"></i>
                    {application.currentcompany && application.currentcompany.length > 2
                      ? application.currentcompany
                      : 'Not specified'}
                  </p>
                </div>
                <div className="badge bg-success h-25">
                  {application.application_status}
                </div>
              </div>
            </div>
          </div>

          <div className="candidate-details">
            <div className="mb-2">
              <i className="fas fa-map-marker-alt me-2"></i>
              {application.city}, {application.state}
            </div>
            <div className="mb-2">
              <i className="fas fa-graduation-cap me-2"></i>
              {application.branch}  - {application.passing_year}
            </div>
            {application.yearsOfExperience && <div className="mb-3">
              <i className="fas fa-briefcase me-2"></i>
              {application.yearsOfExperience} years | {application.currentSalary} LPA
            </div>}

            <div className="skills-section mb-3">
            {application.skills ? (() => {
                    let skillsArray = [];
                    if (typeof application.skills === "string") {
                      try {
                        const parsed = JSON.parse(application.skills);
                        skillsArray = Array.isArray(parsed) ? parsed : [];
                      } catch (err) {
                        return <p>Invalid skill data</p>;
                      }
                    } else if (Array.isArray(application.skills)) {
                      skillsArray = application.skills;
                    }

                    return skillsArray.length > 0 ? (
                      skillsArray.map((skill, index) => (
                        <a href="#" className="m-1 badge badge-secondary text-bg-primary " key={index}>
                          {skill.skill_name}
                        </a>
                      ))
                    ) : (
                      <p>No skills available</p>
                    );
                  })() : (
                    <p>No skills available</p>
                  )}
            </div>

            <div className="candidate-footer d-flex justify-content-between align-items-center">
              <div className="social-links">
                {application.linkedinid && (
                  <a href={application.linkedinid} className="me-2 text-primary" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin"></i>
                  </a>
                )}
                {application.githubid && (
                  <a href={application.githubid} className="me-2 text-dark" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-github"></i>
                  </a>
                )}
              </div>
              <button className="btn btn-primary btn-sm" onClick={() => {
                navigate("/candidate-review", {state: {candidate: {...application, name: application.candidate_name}}})
              }}>View Profile</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



const RecentApplications = ({companyId}) => {
  const [applications, setApplications] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const fetchRecentApplications = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}job_application/recent-applications/${companyId}`);
      setApplications(response.data)
    }
    catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (companyId)
    fetchRecentApplications();
  }, [companyId]);

  return (
    <div className='row'>
      {loading ? (
        <div className="text-center">
          <span className="visually-hidden">Loading...</span>
          </div>
        
      ) : applications.length > 0 ? (
        applications.map((application, index) => (
          <CandidateCard key={index} application={application} />
        ))
      ) : (
        <h4>No recent applications yet!</h4>
      )}
    </div>
  )
}

export default React.memo(RecentApplications);
